import { addAlpha, getColorByBgColor, hexToRgba } from "lib/utils/helpers";
import { trustBadges } from "lib/utils/constants";
import clockImg from "assests/images/clock.svg";
import globeImg from "assests/images/globe.svg";
import lockImg from "assests/images/lock.svg";
import smileImg from "assests/images/smile.svg";
import starImg from "assests/images/star.svg";
import truckImg from "assests/images/truck.svg";
import returnImg from "assests/images/return.svg";

export const customBranding = (primaryColor?: string, primaryTextColor?: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  const isMarketingPopup = searchParams.get("page") === "marketing-popup";
  const isProfilePage = searchParams.get("page") === "profile";

  if (Boolean(primaryColor) && typeof primaryColor !== "undefined") {
    document?.documentElement?.style?.setProperty("--flo-primary-dark-color", `${primaryColor}`);
    document?.documentElement?.style?.setProperty(
      "--flo-primary-light-color",
      `${addAlpha(primaryColor.substring(0, 7), 0.3)}`,
    );
    document?.documentElement?.style?.setProperty(
      "--flo-primary-lighter-color",
      `${addAlpha(primaryColor.substring(0, 7), 0.1)}`,
    );
    document?.documentElement?.style?.setProperty(
      "--flo-primary-with-alpha-05",
      `${hexToRgba(primaryColor.substring(0, 7), 0.05)}`,
    );
    document?.documentElement?.style?.setProperty(
      "--flo-primary-with-alpha-2",
      `${hexToRgba(primaryColor.substring(0, 7), 0.2)}`,
    );
    if (isMarketingPopup) {
      document?.documentElement?.style?.setProperty("--popup-font-family", '"ShopfloPopupFont", "Inter"');
    } else if (isProfilePage) {
      document.body.style.backgroundColor = "bg-white";
    } else {
      document.body.style.backgroundColor = "var(--flo-primary-lighter-color)";
    }

    const primaryColorContrast = primaryTextColor ?? getColorByBgColor(primaryColor);
    document?.documentElement?.style?.setProperty("--flo-primary-btn-text-color", primaryColorContrast);
  }
};

export type ThemeColorMap = Partial<Record<`flo-${string}`, string | undefined>>;

export const injectThemeColors = (themeColors: ThemeColorMap) => {
  if (typeof document === "undefined") return;

  const rootStyle = document.documentElement?.style;
  if (!rootStyle) return;

  Object.entries(themeColors).forEach(([key, value]) => {
    if (!value) return;
    rootStyle.setProperty(`--${key}`, value);
  });
};

export const trustBadgeImgConfig = {
  [trustBadges.CLOCK]: clockImg,
  [trustBadges.RETURN]: returnImg,
  [trustBadges.GLOBE]: globeImg,
  [trustBadges.LOCK]: lockImg,
  [trustBadges.STAR]: starImg,
  [trustBadges.TRUCK]: truckImg,
  [trustBadges.SMILE]: smileImg,
};
